import React from 'react';
import { TruckIcon, MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
export function DeliveryExplainer() {
  return <section className="section-padding bg-brand-green-50 border-y border-brand-green-100" data-id="element-57">
      <div className="container-wide" data-id="element-58">
        {/* Hero delivery message */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-59">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-green text-white mb-6 shadow-lg" data-id="element-60">
            <TruckIcon className="w-10 h-10" data-id="element-61" />
          </div>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-62">
            FREE Drop-off Within 5km
          </h2>
          <p className="text-lg text-gray-600 mb-2" data-id="element-63">
            On eligible orders over $100. Order by 4pm for next-day delivery to
            your door.
          </p>
          <p className="text-sm text-gray-500" data-id="element-64">
            Further away? Contact your local store to arrange delivery. Regional
            WA postage also available.
          </p>
        </div>

        {/* Compact 4-column strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-65">
          <div className="bg-white rounded-xl p-5 text-center shadow-sm border border-gray-100" data-id="element-66">
            <TruckIcon className="w-7 h-7 text-brand-green mx-auto mb-3" data-id="element-67" />
            <div className="font-heading font-bold text-gray-900 text-sm mb-1" data-id="element-68">
              Free Within 5km
            </div>
            <div className="text-xs text-gray-500" data-id="element-69">On orders over $100</div>
          </div>
          <div className="bg-white rounded-xl p-5 text-center shadow-sm border border-gray-100" data-id="element-70">
            <ClockIcon className="w-7 h-7 text-brand-blue mx-auto mb-3" data-id="element-71" />
            <div className="font-heading font-bold text-gray-900 text-sm mb-1" data-id="element-72">
              Next-Day Delivery
            </div>
            <div className="text-xs text-gray-500" data-id="element-73">Order by 4pm</div>
          </div>
          <div className="bg-white rounded-xl p-5 text-center shadow-sm border border-gray-100" data-id="element-74">
            <MapPinIcon className="w-7 h-7 text-brand-blue mx-auto mb-3" data-id="element-75" />
            <div className="font-heading font-bold text-gray-900 text-sm mb-1" data-id="element-76">
              Click & Collect
            </div>
            <div className="text-xs text-gray-500" data-id="element-77">Pick up in-store</div>
          </div>
          <div className="bg-white rounded-xl p-5 text-center shadow-sm border border-gray-100" data-id="element-78">
            <PhoneIcon className="w-7 h-7 text-brand-green mx-auto mb-3" data-id="element-79" />
            <div className="font-heading font-bold text-gray-900 text-sm mb-1" data-id="element-80">
              Regional WA
            </div>
            <div className="text-xs text-gray-500" data-id="element-81">Postage by arrangement</div>
          </div>
        </div>
      </div>
    </section>;
}